var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["product-meta/price.j2"] = require( "product-meta/price.j2" );
dependencies["product-meta.j2"] = require( "product-meta.j2" );
dependencies["controls/product-controls-faceout.j2"] = require( "controls/product-controls-faceout.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/family/family-product-meta.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "product/templates/family/family-product-meta.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("productUrl")) {
var t_4 = t_1.productUrl;
} else {
cb(new Error("cannot import 'productUrl'")); return;
}
context.setVariable("productUrl", t_4);
if(t_1.hasOwnProperty("quickshopUrl")) {
var t_5 = t_1.quickshopUrl;
} else {
cb(new Error("cannot import 'quickshopUrl'")); return;
}
context.setVariable("quickshopUrl", t_5);
var t_6;
t_6 = "family";
frame.set("productTypeOverride", t_6, true);
if(frame.topLevel) {
context.setVariable("productTypeOverride", t_6);
}
if(frame.topLevel) {
context.addExport("productTypeOverride", t_6);
}
output += "\n\n<div class=\"s-product-meta o-row\">\n\n    <div class=\"o-column o-extra-small--12\">\n\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish")) {
output += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "isForFamilyProduct")) {
output += "\n                ";
var t_7;
t_7 = (lineno = 11, colno = 46, runtime.callWrap(t_4, "productUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productSlug"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})]));
frame.set("titleLinkURL", t_7, true);
if(frame.topLevel) {
context.setVariable("titleLinkURL", t_7);
}
if(frame.topLevel) {
context.addExport("titleLinkURL", t_7);
}
output += "\n            ";
;
}
else {
output += "\n                ";
var t_8;
t_8 = (lineno = 13, colno = 48, runtime.callWrap(t_5, "quickshopUrl", context, [env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productMeta")),"url"))]));
frame.set("titleLinkURL", t_8, true);
if(frame.topLevel) {
context.setVariable("titleLinkURL", t_8);
}
if(frame.topLevel) {
context.addExport("titleLinkURL", t_8);
}
output += "\n            ";
;
}
output += "\n\n            <a href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "titleLinkURL"), env.opts.autoescape);
output += "\" class=\"u-small--show c-product-meta__title-link js-product-meta__title-link\">\n\n                <h2 class=\"c-product-meta__h1\" data-qa-product-title>\n\n                    <span>\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productMeta")),"displayName"), env.opts.autoescape);
output += "\n                    </span>\n\n                </h2>\n\n            </a>\n\n            ";
env.getTemplate("product-meta/price.j2", false, "product/templates/family/family-product-meta.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n        ";
})});
}
output += "\n\n        ";
env.getTemplate("product-meta.j2", false, "product/templates/family/family-product-meta.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n\n    </div>\n\n</div>\n\n";
output += "\n";
env.getTemplate("controls/product-controls-faceout.j2", false, "product/templates/family/family-product-meta.j2", null, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
t_17.render(context.getVariables(), frame, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
output += t_18
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/family/family-product-meta.j2"] , dependencies)